import { Box } from "@mui/material";
import { curryN, when } from "ramda";
import { ScrollableRightMenu } from "../../components/ScrollableRightMenu";
import { useAuth } from "../Authorization";
import { AvailabilityCalendar } from "../Availability/AvailabilityCalendar";
import { usePickCoach } from "../Coaches/api";
import { Loaders, QueryRenderer } from "../QM/QueryRenderer";
import { useCoachQuery } from "./api";
import { CoachInfo } from "../Coaches/CoachInfo";
import { getCoachPhotoUrl } from "../Coaches/coach.utils";
import { useImgLoading } from "../../components/Image/useImgLoading";

const errIs = curryN(2, (statusCode, e) => e?.response?.status === statusCode);

export const MessagesRightMenu = ({
  username,
  msg,
  setRightOpen,
  setHasRightMenuToggleIcon,
}) => {
  const { user } = useAuth();
  const coachQuery = useCoachQuery({
    username,
    onError: when(errIs(404), () => {
      console.log("MessagesRightMenu closing right menu for " + username);
      setRightOpen(false);
      setHasRightMenuToggleIcon(false);
    }),
    onSuccess: () => {
      console.log("MessagesRightMenu opening right menu for " + username);
      setRightOpen(true);
      setHasRightMenuToggleIcon(true);
    },
  });
  const pickCoach = usePickCoach({ coach: coachQuery.data });
  const profilePhotoSrc = getCoachPhotoUrl(username);
  const canPickCoach = user.data.coach !== username;

  const avatarImgProps = useImgLoading({ src: profilePhotoSrc });
  console.log("[MessagesRightMenu.rndr]", {
    username,
    coachQuery,
  });

  return (
    <ScrollableRightMenu
      buttonProps={
        canPickCoach &&
        pickCoach.onPick && {
          children: msg("messages.aside.pick-coach"),
          type: "button",
          variant: "outlined",
          disabled: pickCoach.pickPending,
          onClick: () => pickCoach.onPick(),
        }
      }
      sx={{ whiteSpace: "normal" }}
    >
      <Box width="100%" align="left" mt={3}>
        {/* <object data="https://placehold.co/400x400?text=Incognito" type="image/png" > */}
        <Box
          component="img"
          borderRadius={1}
          width={225}
          alignSelf={"center"}
          src={avatarImgProps.src}
          alt={`${username}`}
          onLoad={avatarImgProps.onLoad}
          sx={avatarImgProps.sx}
        />
        {/* </object> */}
      </Box>
      <QueryRenderer
        query={coachQuery}
        loaderEl={<Loaders.CircularBlock fullHeight />}
        errored={({ error }) => {
          // console.log("coachQuery.errored.rndr", { e })
          return null;
        }}
        success={({ data: coach }) => (
          <>
            <CoachInfo coach={coach} maxBioChars={2000} sx={{ my: 3 }} />
            <AvailabilityCalendar coach={coach} />
          </>
        )}
      />
    </ScrollableRightMenu>
  );
};
